export class SaveScreenDialogOpenParam {
    operation: SaveScreenDialogOperations;
    type: SaveScreenDialogType;
    data?: any;
    invoker?: SaveScreenDialogInvoker;
}

export enum SaveScreenDialogOperations {
    CREATE = 'CREATE',
    COPY = 'COPY',
    EDIT = 'EDIT'
}

export enum SaveScreenDialogType {
    RESEARCH_VIEW = 'RESEARCH_VIEW',
    DASHBOARD = 'DASHBOARD',
    HOME_SCREEN = 'HOME_SCREEN'
}

export enum SaveScreenDialogInvoker {
    CREATE_RESEARCH = 'CREATE_RESEARCH',
    SAVED_RESEARCH = 'SAVED_RESEARCH',
    MANAGE_SCREENS = 'MANAGE_SCREENS',
    DASHBOARD = 'DASHBOARD',
    HOME_SCREEN = 'HOME_SCREEN'
}
